import admins from './admins'
import roles from './roles'
import common from './common'
import auth from './auth'
import news from './news'
import products from './products'
import heroBanners from './hero-banners'
import portalMenus from './portal-menus'
import partnerIcons from './partner-icons'
import contactUs from './contact_us'
import catalogues from './catalogues'
import promotions from './promotions'
import services from './services'
import blogs from './blogs'
import jobOpportunities from './job-opportunities'
import importProduct from './import-product'
import productBanners from './product-banners'
import productReviews from './products-reviews'
import csr from './csr'

export default {
  ...auth,
  ...admins,
  ...roles,
  ...common,
  ...news,
  ...products,
  ...heroBanners,
  ...portalMenus,
  ...partnerIcons,
  ...contactUs,
  ...catalogues,
  ...promotions,
  ...services,
  ...blogs,
  ...importProduct,
  ...jobOpportunities,
  ...productBanners,
  ...productReviews,
  ...csr,
}
